import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HeaderNsideService } from '../../SuperAdmin/services/HeaderNside.service';
import { AlertMessages, AlertType } from '../../../core/AlertMessages';



@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  oldPwd: string = '';
  newPwd: string = '';
  rePwd: string = '';


  @Output() cancelAction = new EventEmitter();
  @Output() saveAction = new EventEmitter();

  constructor(private HeaderService: HeaderNsideService,) { }

  ngOnInit() {
  }


  onSubmit(Form: NgForm) {
    // var newpassword: string = Form.value.newPwd;

    setTimeout(() => {
      this.HeaderService.changePassword(Form.value.oldPwd, Form.value.newPwd, Form.value.rePwd).subscribe((message) => {
        message['Id'] === 1 ?
        AlertMessages.Show('Success',
        message['StatusMessage'],
        AlertType.Success) : AlertMessages.Show('Error', message['StatusMessage'], AlertType.Error);
        Form.reset();
      });
    }, 200);
  }

  clearData(Form: NgForm) {
    Form.reset();

  }

}
